import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../base-dialog';
import { UiRouterState } from '../../services/ajs-router-state.service';

@Component({
  selector: 'mandae-select-tour-dialog',
  templateUrl: './select-tour-dialog.component.html',
  styleUrls: ['./select-tour-dialog.component.scss']
})
export class SelectTourDialogComponent extends BaseDialog<SelectTourDialogComponent> implements OnInit {

  public routes = [
    { icon: 'menu:collection', text: 'Coletas', state: 'pedido.encomendas', params: { collectionTour: true }},
    { icon: 'menu:package', text: 'Encomendas', state: 'historico', params: { tour: true } },
    { icon: 'financial:money', text: 'Financeiro', state: 'financeiro', params: { tour: true } },
    { icon: 'menu:charts', text: 'Indicadores', state: 'indicadores', params: { tour: true } },
    { icon: 'menu:chat', text: 'Relacionamento', state: 'relacionamento', params: { tour: true } },
    { icon: 'menu:settings', text: 'Configurações', state: 'minha-conta', params: { tour: true } },
  ];

  constructor(
    dialogRef: MatDialogRef<SelectTourDialogComponent>,
    private state: UiRouterState,
  ) {
    super(dialogRef);
  }

  ngOnInit() {
  }

  public gotoRoute(route: any) {
    this.dialogRef.close();
    this.state.go(route.state, route.params, { reload: true });
  }

}
